// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--2J70x","leaves":"Logo-module--leaves--11O9J","subtitle":"Logo-module--subtitle--1d8VI"};